import auth from './auth';
import quiz from './quiz';
import game from './game';
import launch from './launch';

export default {
  auth,
  quiz,
  game,
  launch,
};
